import { useLocation } from 'react-router-dom';
import { useAuth } from '@/shared/lib/auth';
import { useOptionalPassbook } from '@/shared/lib/passbook';
import { showOwnerAutomatedCampaigns } from '@/shared/lib/navigation';
import type { Passbook } from '@/shared/types';

export const OWNER_CAMPAIGNS_BASE = '/owner/campanhas';

export interface CampaignScope {
  /** id_passbook da API: user._id no Owner, senão o passbook da loja. */
  idPassbook: string;
  listPath: string;
  isOwnerScope: boolean;
  passbook: Passbook | null;
  organizationName: string;
}

/** Escopo das telas automatizadas — loja (`/loja/:id/...`) ou Owner (`/owner/campanhas`). */
export function useCampaignScope(): CampaignScope {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const passbookCtx = useOptionalPassbook();

  const isOwnerScope = Boolean(
    user && showOwnerAutomatedCampaigns(user) && pathname.startsWith(OWNER_CAMPAIGNS_BASE),
  );

  if (isOwnerScope && user) {
    return {
      idPassbook: user._id,
      listPath: OWNER_CAMPAIGNS_BASE,
      isOwnerScope: true,
      passbook: null,
      organizationName: user.name,
    };
  }

  if (!passbookCtx) {
    throw new Error('useCampaignScope deve ser usado em /loja/:id ou /owner/campanhas');
  }

  return {
    idPassbook: passbookCtx.idPassbook,
    listPath: `/loja/${passbookCtx.idPassbook}/push-marketing/campanhas`,
    isOwnerScope: false,
    passbook: passbookCtx.passbook,
    organizationName: passbookCtx.passbook.organizationName,
  };
}
